export interface ContentGenScores {
  contentCreation: number;
  automation: number;
  quality: number;
}

export interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    scores: ContentGenScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    text: "How do you currently create marketing content and documentation?",
    options: [
      {
        text: "Manual writing for every piece of content",
        scores: { contentCreation: 3, automation: 0, quality: 1 },
      },
      {
        text: "Mix of manual writing and templates",
        scores: { contentCreation: 2, automation: 1, quality: 2 },
      },
      {
        text: "Templates with some AI assistance",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Automated content generation with human oversight",
        scores: { contentCreation: 0, automation: 3, quality: 3 },
      },
    ],
  },
  {
    id: 2,
    text: "What's your biggest challenge with content creation?",
    options: [
      {
        text: "Finding time to create enough content",
        scores: { contentCreation: 3, automation: 2, quality: 1 },
      },
      {
        text: "Maintaining consistent quality and brand voice",
        scores: { contentCreation: 2, automation: 1, quality: 3 },
      },
      {
        text: "Generating fresh ideas and variations",
        scores: { contentCreation: 3, automation: 1, quality: 2 },
      },
      {
        text: "Adapting content for different channels and audiences",
        scores: { contentCreation: 2, automation: 2, quality: 2 },
      },
    ],
  },
  {
    id: 3,
    text: "How consistent is your brand voice across all content?",
    options: [
      {
        text: "Varies significantly by author and channel",
        scores: { contentCreation: 1, automation: 1, quality: 3 },
      },
      {
        text: "Somewhat consistent with style guides",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Mostly consistent but requires heavy editing",
        scores: { contentCreation: 2, automation: 1, quality: 3 },
      },
      {
        text: "Very consistent through automated systems",
        scores: { contentCreation: 0, automation: 3, quality: 1 },
      },
    ],
  },
  {
    id: 4,
    text: "How quickly can you produce content when needed?",
    options: [
      {
        text: "Days to weeks for most content pieces",
        scores: { contentCreation: 3, automation: 3, quality: 1 },
      },
      {
        text: "1-2 days with current resources",
        scores: { contentCreation: 2, automation: 2, quality: 2 },
      },
      {
        text: "Same day for simple content",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Minutes to hours with AI assistance",
        scores: { contentCreation: 0, automation: 1, quality: 3 },
      },
    ],
  },
  {
    id: 5,
    text: "How do you handle content personalization for different audiences?",
    options: [
      {
        text: "One-size-fits-all content for everyone",
        scores: { contentCreation: 3, automation: 2, quality: 2 },
      },
      {
        text: "Manual customization for major segments",
        scores: { contentCreation: 2, automation: 2, quality: 2 },
      },
      {
        text: "Template-based variations for key audiences",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Automated personalization at scale",
        scores: { contentCreation: 0, automation: 3, quality: 2 },
      },
    ],
  },
  {
    id: 6,
    text: "What's your content repurposing process like?",
    options: [
      {
        text: "We rarely repurpose existing content",
        scores: { contentCreation: 3, automation: 3, quality: 1 },
      },
      {
        text: "Manual reformatting when time allows",
        scores: { contentCreation: 2, automation: 2, quality: 2 },
      },
      {
        text: "Semi-automated with templates",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Fully automated across multiple formats",
        scores: { contentCreation: 0, automation: 2, quality: 3 },
      },
    ],
  },
  {
    id: 7,
    text: "How do you ensure content accuracy and compliance?",
    options: [
      {
        text: "Manual review with frequent oversights",
        scores: { contentCreation: 2, automation: 1, quality: 3 },
      },
      {
        text: "Multiple rounds of human review",
        scores: { contentCreation: 1, automation: 1, quality: 3 },
      },
      {
        text: "Checklists and review workflows",
        scores: { contentCreation: 1, automation: 2, quality: 2 },
      },
      {
        text: "Automated compliance checks with AI validation",
        scores: { contentCreation: 0, automation: 3, quality: 2 },
      },
    ],
  },
];
